import type { Country } from '../../../constants/country/country';
import type { Currency } from '../../../constants/currency/currency';

export type GetGeoLocationRequest = {
  ip?: string;
};

export type GeoLocationNull = '-';

export type GetGeoLocationResponse = {
  countryCode: Country | GeoLocationNull;
  country: string | GeoLocationNull;
  region: string | GeoLocationNull;
  city: string | GeoLocationNull;
  zipCode: string | GeoLocationNull;
  timeZone: string | GeoLocationNull;
  currency: Currency | GeoLocationNull;
};
